import { NavBar } from './NavBar';
if (!window.customElements.get('bt-navbar')) {
    window.customElements.define('bt-navbar', NavBar);
}
